export const styles = {
  root: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    marginBottom: "20px",
  },
  title: {
    lineHeight: "36px",
  },
  text: {
    color: "events.lightBlack",
  },
};
